import { PersonalDetailsSchema } from './PersonalDetails.styles';

export const personalDetailsStyles: PersonalDetailsSchema = {
  wrapperBox: {
    bg: 'white',
    p: '2',
    sx: {
      '&&': {
        '.chakra-input': {
          borderLeftRadius: 'md',
          borderLeft: '1px',
          borderColor: 'gray.300',
          bg: 'gray.50',
          color: 'black',
          _hover: {
            bg: 'gray.100',
            borderColor: 'gray.400',
          },
        },
        '.chakra-form__label': {
          color: 'gamma.900',
        },
      },
    },
    rounded: 'base',
  },
};
